<div class="d-flex flex-column gap-2 data-pill">
  <div class="label">{{ label }}</div>
  <div class="value">{{ value }}</div>
</div>
